import type { GeoBrowseDegRow } from '../../types';
import BrowseDataTable, { type BrowseColumn } from '../BrowseDataTable';

const COLUMNS: BrowseColumn<GeoBrowseDegRow>[] = [
  { id: 'gene_symbol', label: 'gene_symbol', accessor: r => r.gene_symbol },
  { id: 'baseMean', label: 'baseMean', accessor: r => Math.round(r.baseMean) },
  { id: 'log2FoldChange', label: 'log2FoldChange', accessor: r => r.log2FoldChange.toFixed(3) },
  { id: 'lfcSE', label: 'lfcSE', accessor: r => r.lfcSE.toFixed(3) },
  { id: 'stat', label: 'stat', accessor: r => r.stat.toFixed(2) },
  { id: 'pvalue', label: 'pvalue', accessor: r => r.pvalue.toExponential(2) },
  { id: 'padj', label: 'padj', accessor: r => r.padj.toExponential(2) },
];

type TopDegsTableProps = {
  rows: GeoBrowseDegRow[];
};

export default function TopDegsTable({ rows }: TopDegsTableProps) {
  return (
    <BrowseDataTable
      rows={rows}
      columns={COLUMNS}
      rowKey={r => String(r.gene_id)}
      pageSizeOptions={[10, 25, 50]}
    />
  );
}
